import { render, staticRenderFns } from "./PageSide.vue?vue&type=template&id=6d10da2f&scoped=true&"
import script from "./PageSide.vue?vue&type=script&lang=js&"
export * from "./PageSide.vue?vue&type=script&lang=js&"
import style0 from "./PageSide.vue?vue&type=style&index=0&id=6d10da2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10da2f",
  null
  
)

export default component.exports